import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { MuiGrid, MuiTypography, MuiCard, MuiButton, MuiAddCircle, MuiDoubleArrow, MuiYouTube } from '../../ui/MaterialUIComponents';
import theme from '../../../assests/theme'
import CreateScheduleDialog from '../school/schedule/CreateScheduleDialog'

const useStyles = makeStyles(theme => ({
  root: { boxSizing: 'border-box', padding: 8 },
  mainRoot: { marginTop: '2vh', border: '1px solid ' + theme.palette.grey.dark },
  headerStyle: { background: theme.palette.primary.main, width: '100%', height: "auto", boxSizing: 'content-box', padding: 8 },
  headerTextStyle: { textTransform: 'none', font: "Bold 14px/16px Arial", color: '#fff' },
  footerStyle: { borderTop: '1px solid ' + theme.palette.grey.main, padding: 8 }
}));

export default function CreateNewScheduleStepsCardComponent(props) {
  const classes = useStyles();
  const [openCreateScheduleDialog, setOpenDialog] = React.useState(false);
  const toggleCreateScheduleDialogMethod = event => {
    setOpenDialog(prevOpen => !prevOpen);
  };
  const updateList = () => { }
  const createScheduleDialog = () => {
    const { classes, i18n } = props
    return (
      <CreateScheduleDialog type="create" title={i18n.schedule.createScheduleText} description={i18n.schedule.createScheduleDescription} updateList={updateList} toggleCreateScheduleDialogMethod={toggleCreateScheduleDialogMethod} open={openCreateScheduleDialog} {...props} >
      </CreateScheduleDialog>

    )
  }
  const { i18n } = props
  return (
    <MuiGrid justify="center"
      alignItems="center" container xs={12} >
      <MuiGrid style={{ padding: 10 }} container xs={6}
      >
        <MuiCard className={classes.mainRoot}
        >
          <MuiGrid
            container xs={12}
            justify="center"
            alignItems="center"
            className={classes.headerStyle}>
            {openCreateScheduleDialog ? createScheduleDialog() : null}
            <MuiButton onClick={toggleCreateScheduleDialogMethod} >
              <MuiAddCircle style={{ color: theme.palette.orange, }} fontSize='large' />&nbsp;
              <MuiTypography className={classes.headerTextStyle}>
                {i18n.schedule.createNewScheduleText}
              </MuiTypography>
            </MuiButton>
          </MuiGrid>
          <MuiGrid container xs={12} className={classes.root}>
            <MuiGrid item xs={12} align='left'>
              <MuiTypography style={theme.typography.body}><b>1.</b>{i18n.schedule.createScheduleStep1Title}</MuiTypography>
              <MuiTypography style={theme.typography.body}>
                {i18n.schedule.createScheduleStep1Text}
              </MuiTypography>
              <br />
            </MuiGrid>

            <MuiGrid item xs={12} align='left'>
              <MuiTypography style={theme.typography.body}><b>2.</b>{i18n.schedule.createScheduleStep2Title}</MuiTypography>
              <MuiTypography style={theme.typography.body}>
                {i18n.schedule.createScheduleStep2Text}
              </MuiTypography>
              <br />
            </MuiGrid>

            <MuiGrid item xs={12} align='left'>
              <MuiTypography style={theme.typography.body}><b>3.</b>{i18n.schedule.createScheduleStep3Title}</MuiTypography>
              <MuiTypography style={theme.typography.body}>
                {i18n.schedule.createScheduleStep3Text}
              </MuiTypography>
              <br />
            </MuiGrid>
            <MuiGrid item xs={12} align='left'>
              <MuiTypography style={theme.typography.body}><b>4.</b>{i18n.schedule.createScheduleStep4Title}</MuiTypography>
              <MuiTypography style={theme.typography.body}>
                {i18n.schedule.createScheduleStep4Text}
              </MuiTypography>
              <br />
            </MuiGrid>
          </MuiGrid>
          <MuiGrid
            container
            className={classes.footerStyle}
            xs={12}
            justify="center" >
            <MuiGrid item xs={5} align="center" >
              <MuiButton>{i18n.commonTexts.learnMore}&nbsp;<MuiDoubleArrow color='primary' /></MuiButton>
            </MuiGrid>
            <MuiGrid item xs={7} align="center" >
              <MuiButton>{i18n.commonTexts.watchHelpVideo}&nbsp;<MuiYouTube color='primary' /></MuiButton>
            </MuiGrid>
          </MuiGrid>
        </MuiCard></MuiGrid></MuiGrid>
  );
}
